import dataCollection from '../_index';

export const viewPage = async (vuex, args) => {
  dataCollection.viewPage(vuex, args);
};

export const viewCollection = async (vuex, args) => {
  dataCollection.viewCollection(vuex, args);
};

export const viewSales = async (vuex, args) => {
  dataCollection.viewSales(vuex, args);
};

export const viewThankYou = async (vuex, args) => {
  dataCollection.viewThankYou(vuex, args);
};

export const eventAddToCart = async (vuex, args) => {
  dataCollection.addToCart(vuex, args);
};

export const eventRemoveFromCart = async (vuex, args) => {
  dataCollection.removeFromCart(vuex, args);
};

export const eventApplyCoupon = async (vuex, args) => {
  dataCollection.applyCoupon(vuex, args);
};

export const eventChangeQuantity = async (vuex, args) => {
  dataCollection.changeQuantity(vuex, args);
};

export const eventChangeColor = async (vuex, args) => {
  dataCollection.changeColor(vuex, args);
};

export const eventChangeSize = async (vuex, args) => {
  dataCollection.changeSize(vuex, args);
};

export const eventInitiateCheckout = async (vuex, args) => {
  dataCollection.initiateCheckout(vuex, args);
};

export const eventCompleteOrder = async (vuex, args) => {
  dataCollection.completeOrder(vuex, args);
};

export const eventInitiateCheckoutUpsell = async (vuex, args) => {
  dataCollection.initiateCheckoutUpsell(vuex, args);
};

export const eventCompleteOrderUpsell = async (vuex, args) => {
  dataCollection.completeOrderUpsell(vuex, args);
};

export const eventIdentify = async vuex => {
  dataCollection.identify(vuex);
};

export const eventRegister = async vuex => {
  dataCollection.register(vuex);
};

export const eventLogin = async vuex => {
  dataCollection.login(vuex);
};

export const eventSearch = async vuex => {
  dataCollection.search(vuex);
};

export const eventContinueShopping = async vuex => {
  dataCollection.continueShopping(vuex);
};